module.exports = __webpack_public_path__ + "static/media/maternity3.6d7d78df.jpg";